<template>
  <div class="admin-shell">
    <v-container>
      <div class="header-section d-flex justify-end" :class="{ 'flex-column': $vuetify.breakpoint.smAndDown }">
        <v-btn
          color="orange"
          :class="{ 'mb-5': $vuetify.breakpoint.smAndDown }"
          class="mx-5 white--text"
          @click="$router.push({ name: 'ReservationTypeSelection' })"
          >TEST Reservierungen (Kundensicht)</v-btn
        >
        <v-btn color="primary" class="new-type-btn" @click="$router.push({ name: 'ReservationToolAdmin' })" :disabled="!studioId">
          <v-icon left>mdi-cog</v-icon>
          Formulare verwalten
        </v-btn>
      </div>
      <v-dialog v-model="createDialog" max-width="700px" persistent>
        <v-card dark class="dialog-card">
          <v-card-title class="dialog-title">
            <span>Neue Buchung anlegen</span>
          </v-card-title>

          <v-window v-model="step">
            <v-window-item :value="1">
              <v-card-text>
                <h3 class="step-headline">1. Für wen ist die Buchung?</h3>
                <user-search ignoreRights class="mx-auto" label="Mitglied suchen..." @update="updateNewAssignedUser"></user-search>
              </v-card-text>
              <v-card-actions class="dialog-actions">
                <v-spacer></v-spacer>
                <v-btn text @click="closeCreateDialog">Abbrechen</v-btn>
                <v-btn class="save-btn" @click="step = 2" :disabled="!newBooking.user">Weiter</v-btn>
              </v-card-actions>
            </v-window-item>

            <v-window-item :value="2">
              <v-card-text>
                <h3 class="step-headline">2. Was & Wann?</h3>
                <v-select
                  :items="reservationTypes"
                  item-text="name"
                  item-value="_id"
                  v-model="newBooking.reservationType"
                  label="Leistung auswählen"
                  filled
                  dark
                  @change="fetchTimeslotsForNewBooking"></v-select>
                <v-date-picker
                  v-if="newBooking.reservationType"
                  v-model="newBooking.date"
                  full-width
                  dark
                  color="var(--primary)"
                  @input="fetchTimeslotsForNewBooking"></v-date-picker>
              </v-card-text>
              <v-card-actions class="dialog-actions">
                <v-spacer></v-spacer>
                <v-btn text @click="step = 1">Zurück</v-btn>
                <v-btn class="save-btn" @click="step = 3" :disabled="!newBooking.date">Weiter</v-btn>
              </v-card-actions>
            </v-window-item>

            <v-window-item :value="3">
              <v-card-text>
                <h3 class="step-headline">3. Verfügbare Zeit wählen</h3>
                <div v-if="isFetchingSlots" class="text-center pa-8">
                  <v-progress-circular indeterminate color="var(--primary)"></v-progress-circular>
                </div>
                <div v-else-if="availableSlots.length" class="timeslot-grid">
                  <v-btn
                    v-for="slot in availableSlots"
                    :key="slot.time"
                    @click="
                      newBooking.startTime = slot.time
                      step = 4
                    "
                    class="timeslot-btn">
                    {{ formatTime(slot.time) }}
                  </v-btn>
                </div>
                <div v-else class="text-center pa-4">Keine freien Termine für diesen Tag gefunden.</div>
              </v-card-text>
              <v-card-actions class="dialog-actions">
                <v-spacer></v-spacer>
                <v-btn text @click="step = 2">Zurück</v-btn>
              </v-card-actions>
            </v-window-item>

            <v-window-item :value="4">
              <v-card-text class="text-center">
                <h3 class="step-headline">4. Buchung überprüfen</h3>
                <p>
                  Bitte bestätige die Buchung für <br /><strong>{{ selectedUserName }}</strong>
                </p>
                <v-chip color="var(--primary)" class="my-3" large> {{ selectedTypeName }} am {{ formatDateTime(newBooking.startTime) }} </v-chip>
              </v-card-text>
              <v-card-actions class="dialog-actions">
                <v-spacer></v-spacer>
                <v-btn text @click="step = 3">Zurück</v-btn>
                <v-btn class="save-btn" @click="createBooking" :loading="isSaving">Jetzt Buchen</v-btn>
              </v-card-actions>
            </v-window-item>
          </v-window>
        </v-card>
      </v-dialog>

      <v-card class="filter-card" flat>
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="5">
              <v-menu v-model="startDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedStartDate"
                    label="Start-Datum"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dark
                    filled></v-text-field>
                </template>
                <v-date-picker
                  v-model="filters.startDate"
                  @input="
                    startDateMenu = false
                    fetchReservations()
                  "></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="5">
              <v-menu v-model="endDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedEndDate"
                    label="End-Datum"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dark
                    filled></v-text-field>
                </template>
                <v-date-picker
                  v-model="filters.endDate"
                  @input="
                    endDateMenu = false
                    fetchReservations()
                  "></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-row>
        <v-col align="center" cols="12">
          <v-btn color="primary" class="new-type-btn" @click="openCreateDialog()" :disabled="!studioId">
            <v-icon left>mdi-plus-circle</v-icon>
            Neue Buchung
          </v-btn>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="reservations"
        class="elevation-1 type-table mt-4"
        dark
        :loading="isLoading"
        loading-text="Lade Buchungen..."
        no-data-text="Keine Buchungen im gewählten Zeitraum gefunden.">
        <template v-slot:item.user="{ item }">
          {{ item.user ? `${item.user.vorname} ${item.user.nachname}` : "N/A" }}
        </template>
        <template v-slot:item.startTime="{ item }">
          {{ formatDateTime(item.startTime) }}
        </template>
        <template v-slot:item.reservationType="{ item }">
          {{ item.reservationType ? item.reservationType.name : "N/A" }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon @click="deleteItem(item)" color="red">
            <v-icon>mdi-delete-outline</v-icon>
          </v-btn>
        </template>
      </v-data-table>

      <v-dialog v-model="deleteDialog" max-width="500px">
        <v-card dark class="dialog-card">
          <v-card-title class="dialog-title justify-center">Löschen bestätigen</v-card-title>
          <v-card-text class="text-center mt-2"> Möchtest du diese Buchung wirklich stornieren? </v-card-text>
          <v-card-actions class="dialog-actions">
            <v-spacer></v-spacer>
            <v-btn text @click="closeDeleteDialog">Abbrechen</v-btn>
            <v-btn color="red" @click="deleteItemConfirm" :loading="isDeleting">Ja, stornieren</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import api from "@/api"
import userService from "@/services/userService"
import moment from "moment"
import userSearch from "@/components/userSearch.vue"
export default {
  components: {
    userSearch,
  },
  data: () => ({
    isLoading: true,
    isDeleting: false,
    reservations: [],
    studioId: null,
    deleteDialog: false,
    itemToDelete: null,
    startDateMenu: false,
    endDateMenu: false,
    filters: {
      startDate: moment().startOf("day").format("YYYY-MM-DD"),
      endDate: moment().endOf("day").add(1, "day").format("YYYY-MM-DD"),
    },
    headers: [
      { text: "Mitglied", value: "user" },
      { text: "Datum & Zeit", value: "startTime" },

      { text: "Leistung", value: "reservationType" },
      { text: "Aktionen", value: "actions", sortable: false, align: "right" },
    ],
    createDialog: false,
    step: 1,
    isSaving: false,
    isFetchingSlots: false,
    reservationTypes: [], // Für die Auswahl im Dialog
    availableSlots: [], // Für die Zeitauswahl
    newBooking: {
      user: null,
      reservationType: null,
      date: moment().format("YYYY-MM-DD"),
      startTime: null,
    },
    selectedUserName: null,
  }),

  computed: {
    formattedStartDate() {
      return moment(this.filters.startDate).format("DD.MM.YYYY")
    },
    formattedEndDate() {
      return moment(this.filters.endDate).format("DD.MM.YYYY")
    },

    selectedTypeName() {
      const type = this.reservationTypes.find((t) => t._id === this.newBooking.reservationType)
      return type ? type.name : ""
    },
  },

  created() {
    this.studioId = userService.getStudio()?._id || null
    if (this.studioId) {
      this.fetchReservations()
      this.fetchReservationTypesForDialog()
    } else {
      this.isLoading = false
    }
  },

  methods: {
    async fetchReservations() {
      this.isLoading = true
      try {
        const params = {
          startDate: this.$moment(this.filters.startDate).startOf("day").toISOString(),
          endDate: this.$moment(this.filters.endDate).endOf("day").toISOString(),
        }
        const response = await api.reservationTool.getReservationsForAdmin(params)
        this.reservations = response.data
      } catch (error) {
        console.error("Fehler beim Laden der Reservierungen:", error)
      } finally {
        this.isLoading = false
      }
    },

    resetFilters() {
      this.filters.startDate = moment().startOf("day").format("YYYY-MM-DD")
      this.filters.endDate = moment().endOf("day").add(1, "day").format("YYYY-MM-DD")
      this.fetchReservations()
    },

    openCreateDialog() {
      this.resetNewBooking()
      this.createDialog = true
    },

    closeCreateDialog() {
      this.createDialog = false
    },

    resetNewBooking() {
      this.step = 1
      this.newBooking = {
        user: null,
        reservationType: null,
        date: moment().format("YYYY-MM-DD"),
        startTime: null,
      }
      this.availableSlots = []
    },

    async updateNewAssignedUser(user) {
      this.newBooking.user = user
      let customer = await api.getUserForManager(user)
      this.selectedUserName = `${customer.vorname} ${customer.nachname}`
    },

    async fetchReservationTypesForDialog() {
      try {
        const response = await api.reservationTool.getReservationTypesForAdmin(this.studioId)
        this.reservationTypes = response.data.filter((type) => type.active)
      } catch (error) {
        console.error("Fehler beim Laden der Typen für Dialog:", error)
      }
    },

    async fetchTimeslotsForNewBooking() {
      if (!this.newBooking.reservationType || !this.newBooking.date) return
      this.isFetchingSlots = true
      this.availableSlots = []
      try {
        const response = await api.reservationTool.getTimeslots(this.newBooking.reservationType, this.newBooking.date)
        // Nur die nicht-gebuchten Slots anzeigen
        this.availableSlots = response.data.filter((slot) => !slot.isBooked)
      } catch (error) {
        console.error("Fehler beim Laden der Timeslots:", error)
      } finally {
        this.isFetchingSlots = false
      }
    },

    async createBooking() {
      this.isSaving = true
      const type = this.reservationTypes.find((t) => t._id === this.newBooking.reservationType)
      const bookingData = {
        title: type.name,
        studio: this.studioId,
        user: this.newBooking.user,
        startTime: this.newBooking.startTime,
        endTime: moment(this.newBooking.startTime).add(type.timeslotDuration, "minutes").toISOString(),
        isBooked: true,
        reservationType: this.newBooking.reservationType,
      }

      try {
        await api.reservationTool.createReservation(bookingData)
        this.fetchReservations() // Haupttabelle aktualisieren
      } catch (error) {
        console.error("Fehler beim Erstellen der Buchung:", error)
      } finally {
        this.isSaving = false
        this.closeCreateDialog()
      }
    },

    formatTime(date) {
      return this.$moment(date).format("HH:mm")
    },
    formatDateTime(date) {
      return this.$moment(date).format("DD.MM.YYYY [um] HH:mm")
    },

    deleteItem(item) {
      this.itemToDelete = item
      this.deleteDialog = true
    },

    closeDeleteDialog() {
      this.deleteDialog = false
      this.itemToDelete = null
    },

    async deleteItemConfirm() {
      this.isDeleting = true
      try {
        await api.reservationTool.deleteReservation(this.itemToDelete._id)
        this.fetchReservations() // Liste neu laden
      } catch (error) {
        console.error("Fehler beim Löschen der Reservierung:", error)
      } finally {
        this.isDeleting = false
        this.closeDeleteDialog()
      }
    },
  },
}
</script>

<style scoped>
.step-headline {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: center;
}
.timeslot-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 12px;
  padding-top: 8px;
  max-height: 300px;
  overflow-y: auto;
}
.timeslot-btn {
  background-color: var(--border) !important;
  color: var(--text-primary) !important;
  border-radius: 12px !important;
  font-weight: 600;
  height: 48px !important;
}
/* Das CSS aus dem letzten Vorschlag kann hier größtenteils übernommen werden */
.admin-shell {
  --primary: #00f2ea;
  --bg: #121212;
  --card-bg: #1e1e1e;
  --text-primary: #ffffff;
  --text-secondary: #b0b0b0;
  --border: #2c2c2c;
  --primary-text: #000000;

  min-height: 100vh;
  padding: 40px 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}
.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
.headline {
  font-size: clamp(1.8rem, 5vw, 2.2rem);
  font-weight: 800;
  color: var(--text-primary);
}
.new-type-btn {
  color: white !important;
  font-weight: 700;
  border-radius: 12px;
}
.filter-card {
  background-color: var(--card-bg) !important;
  border: 1px solid var(--border) !important;
  border-radius: 16px !important;
  padding: 8px;
  margin-bottom: 24px;
}
.type-table {
  background-color: var(--card-bg) !important;
  border-radius: 16px !important;
  border: 1px solid var(--border);
}
.dialog-card {
  border-radius: 20px !important;
  border: 1px solid var(--border);
}
.dialog-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
}
.dialog-actions {
  padding: 16px 24px !important;
}
</style>
